export const education = [
  {
    title: "Ingeniería de Software",
    institution: "Institución Universitaria Pascual Bravo",
    period: "2023 — Actualidad · 8.º semestre",
    description: "En curso, Medellín.",
  },
  {
    title: "Tecnología en Desarrollo de Software",
    institution: "Institución Universitaria Pascual Bravo",
    period: "2023 — 2025",
    description: "Título obtenido. Base técnica en programación, bases de datos y desarrollo web.",
  },
  {
    title: "Bachiller Técnico",
    institution: "Colegio I.E. Dinamarca",
    period: "2012 — 2022",
    description: "Educación básica y media técnica.",
  },
];

export const certifications = [
  {
    title: "PL-900",
    name: "Microsoft Power Platform Fundamentals",
    period: "2025",
  },
  {
    title: "PL-200",
    name: "Microsoft Power Platform Functional Consultant",
    period: "2025",
  },
  {
    title: "Scrum",
    name: "Scrum Fundamentals Certification — CertiProf",
    period: "2024",
  },
  {
    title: "EN · B2",
    name: "Inglés Intensivo Conversacional — CIA Idiomas",
    period: "2024 — 2025",
  },
];
